<template>
    <div
        v-if="logos"
        class="logo-marquee"
        :style="cssVars"
    >
        <div class="marquee">
            <div
                v-for="logo in allLogos"
                :key="logo.id"
                class="image-container"
            >
                <img
                    :src="baseURL + logo.url"
                    :alt="logo.alternativeText"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SchoolLogoMarquee',

    props: {
        logos: {
            type: Array,
            required: true,
        },

        animationSpeed: {
            type: Number,
            default: 15,
        },
    },

    data() {
        return {
            baseURL: process.env.VUE_APP_CMS_BASE_URL ?? 'https://dev.cms.edurent.com',

        }
    },

    computed: {
        allLogos() {
            return [].concat(this.logos, this.logos);
        },

        logoCount() {
            return this.logos.length <= 5 ? 10 : this.logos.length;
        },

        cssVars () {
            return {
                '--speed': this.animationSpeed + 's',
            };
        }
    },

    beforeMount() {
        this.init();
    },

    methods: {
        async init() {},
    },
};
</script>

<style scoped lang="scss">
@keyframes marquee {
    0% {
        --webkit-transform: translateX(0);
        transform: translateX(0);
    }

    100% {
        --webkit-transform: translateX(-50%);
        transform: translateX(-50%);
    }
}

.logo-marquee {
    height: 72px;
    width: 100vw;
    position: relative;
    overflow: hidden;
    background-color: black;

    div.marquee {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        overflow: hidden;
        white-space: nowrap;
        animation: marquee var(--speed) linear infinite;

        div.image-container {
            height: 100%;

            img {
                display: block;
                height: 100%;
                width: auto;
                min-width: 72px;
                margin: 0 2vw;
            }
        }
    }

    &:hover div.marquee {
        animation-play-state: paused;
    }
}
</style>
